import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import querystring from "querystring";
import { Group, log } from "../../utils/logger";
import { toastr } from "react-redux-toastr";

// State management
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { signInUser, getDesiredPage, whoami } from "../../state/actions/userActions";

// UI Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  CustomInput, // RememberMe Toggle
} from "reactstrap";

import logo from "../../assets/img/brands/mb_logo.png";
import LogInMicrosoft from "./SSO.Saml";

export class SignIn extends Component {
  constructor(props) {
    super(props);

    // Get query string and parse into object
    const query_string = window.location.search.replace(/^\?/, "");
    const query_object = querystring.parse(query_string);
    props.history.push({ search: "" }); // Clear query string;

    this.state = {
      user: {
        email: "",
        password: "",
        rememberMe: false,
      },
      reason: query_object.reason,
    };

    this.LoggerGroup = new Group("Sign In", { disable: true });
    this.LoggerGroup.emit("Loaded");

    this.onChange = this.onChange.bind(this);
    this.onSignIn = this.onSignIn.bind(this);
  }

  componentDidMount() {
    const { reason } = this.state;

    if (reason) {
      switch (reason) {
        case "expired":
          setTimeout(() => {
            toastr.light("Your authentication has expired, please log in again", {
              icon: "success",
              status: "success",
            });
          }, 500);
          break;
        default:
          log("Unknown reason");
      }
    }
    this.props.whoami();
  }

  onChange({ target }) {
    const { user } = this.state;
    user[target.name] = target.type === "checkbox" ? target.checked : target.value;

    this.LoggerGroup.debounce(`[i] Updated ${target.name}[${user[target.name]}]`);

    this.setState({ user });
  }

  onSignIn() {
    const { user } = this.state;
    this.LoggerGroup.emit(`[i] Sending user credentials`);

    this.props.signInUser(user);
  }

  render() {
    const { loading, errors, isAuthenticated } = this.props;
    const { email, password, rememberMe } = this.state.user;

    if (isAuthenticated) {
      const redirect_to_url = this.props.getDesiredPage();

      this.LoggerGroup.emit(`[i] Authenticated, sending to url[${redirect_to_url}]`).end();
      return <Redirect to={redirect_to_url} />;
    }

    return (
      <React.Fragment>
        <div className="text-center mt-4">
          <h2>Welcome</h2>

          <p className="lead">Sign in to your account to continue</p>
        </div>

        <Card>
          <CardBody>
            <div className="m-sm-4">
              <div className="text-center">
                <img src={logo} alt="Message Broadcast" className="img-fluid" width="300" />
              </div>

              <Form>
                <FormGroup>
                  <Label>Email</Label>
                  <Input
                    bsSize="lg"
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={this.onChange}
                    invalid={!!errors.email}
                  />

                  <FormFeedback>{errors.email}</FormFeedback>
                </FormGroup>

                <FormGroup>
                  <Label>Password</Label>
                  <Input
                    bsSize="lg"
                    type="password"
                    name="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={this.onChange}
                    invalid={!!errors.password}
                  />

                  <FormFeedback>{errors.password}</FormFeedback>

                  {
                    <small>
                      <Link to="/auth/request-reset">Forgot password?</Link>
                    </small>
                  }
                </FormGroup>

                <div>
                  <CustomInput
                    type="switch"
                    id="rememberMe"
                    name="rememberMe"
                    label="Remember me for 30 days"
                    checked={rememberMe}
                    onChange={this.onChange}
                  />
                </div>

                <div className="text-center mt-3">
                  <Button
                    type="button"
                    color="primary"
                    size="lg"
                    onClick={this.onSignIn}
                    disabled={loading}
                  >
                    Sign in
                    {loading && <FontAwesomeIcon icon={faSpinner} className="ml-2" spin />}
                  </Button>
                </div>
                <div className="text-center mt-3">
                  <LogInMicrosoft />
                </div>
              </Form>
            </div>
          </CardBody>

          <CardBody className="text-right d-none">
            <small>
              Don't have an account? <Link to="register">Register here.</Link>
            </small>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

SignIn.propTypes = {
  loading: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  signInUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.user.loading,
  errors: state.user.errors,
  isAuthenticated: state.user.isAuthenticated,
  user: {
    email: state.user.email,
    rememberMe: state.user.rememberMe,
    // do not load password
  },
});

export default connect(mapStateToProps, { signInUser, getDesiredPage, whoami })(SignIn);
